import { Text, Pressable } from "react-native";
import { AnchorProps } from "./types";

export default function Anchor({ children, aClassName, href, target }: AnchorProps) {
  const webProps = target ? { href, hrefAttrs: { target } } : { href };
  // render a Text on web since react-native-web takes care of coverting to `a` when `href` is present
  const Component = typeof children === "string" ? Text : Pressable;
  return (
    <Component className={aClassName} {...webProps}>
      {children}
    </Component>
  );
}
